/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Availability_WaitingInputs */

const en_nav_availability_waiting = /** @type {(inputs: Nav_Availability_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Availability to resolve`)
};

/**
* | output |
* | --- |
* | "Availability to resolve" |
*
* @param {Nav_Availability_WaitingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_availability_waiting = /** @type {((inputs?: Nav_Availability_WaitingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Availability_WaitingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_availability_waiting(inputs)
});